import { HStack } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { useModal } from "components/Modal";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";
import { IAppointmentDetails } from "../../../../application/types/IAppointmentDetails";
import { CancelationUserAppointmentModal } from "../../../CancelationUserAppointmentModal";
import { CancellationUserAppointmentReasonModal } from "../../../CancellationUserAppointmentReasonModal";
import { AppointmentStatus } from "../../../../application/types/AppointmentStatus";
import { EditAppointmentButton } from "../../components/ActionButtons/EditAppointmentButton";
import { CancelAppointmentButton } from "../../components/ActionButtons/CancelAppointmentButton";
import { CancelReasonAppointmentButton } from "../../components/ActionButtons/CancelReasonAppointmentButton";

interface IProps {
  appointment: IAppointmentDetails;
}

const AppointmentActionButtons = ({ appointment }: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const history = useHistory();

  const {
    isOpen: isOpenCancelModal,
    onOpen: onOpenCancelModal,
    onClose: onCloseCancelModal,
  } = useModal();
  const {
    isOpen: isOpenCancelReasonModal,
    onOpen: onOpenCancelReasonModal,
    onClose: onCloseCancelReasonModal,
  } = useModal();

  return (
    <>
      <CancelationUserAppointmentModal
        appointmentId={appointment.appointmentId}
        onClose={onCloseCancelModal}
        isOpen={isOpenCancelModal}
      />
      <CancellationUserAppointmentReasonModal
        deleteReason={appointment.cancellationReason}
        isOpen={isOpenCancelReasonModal}
        onClose={onCloseCancelReasonModal}
      />

      <HStack>
        {appointment.status === AppointmentStatus.Approved && (
          <>
            <EditAppointmentButton
              onClick={(e) => {
                e.stopPropagation();
                history.push(
                  `/e-rezerwacja/${friendlyUrl}/uzytkownik/aktualne-wizyty/${appointment.appointmentId}/edycja`
                );
              }}
              appointmentId={appointment.appointmentId}
            />
            <CancelAppointmentButton
              onClick={(e) => {
                e.stopPropagation();
                onOpenCancelModal();
              }}
              appointmentId={appointment.appointmentId}
            />
          </>
        )}

        {appointment.status === AppointmentStatus.Canceled && (
          <CancelReasonAppointmentButton
            onClick={(e) => {
              e.stopPropagation();
              onOpenCancelReasonModal();
            }}
            appointmentId={appointment.appointmentId}
          />
        )}
      </HStack>
    </>
  );
};

export { AppointmentActionButtons };
